import mimeDb from 'mime-db';

// Duplicate File Validation Interface
export interface IDuplicateValidationOptions {
  enabled: boolean;
  currentEntryId?: string;
  duplicateCheckFn?: (file: File) => boolean;
}

// Custom MIME types
export const fileUploadTypes = {
  'application/doc': {
    source: 'iana',
    extensions: ['doc'],
  },
  'application/mspowerpoint': {
    source: 'iana',
    extensions: ['ppt'],
  },
  'application/x-rtf': {
    source: 'iana',
    extensions: ['rtf'],
  },
  'image/jpg': {
    source: 'iana',
    extensions: ['jpg'],
  },
  'image/tif': {
    source: 'iana',
    extensions: ['tif'],
  },
};

Object.assign(mimeDb, fileUploadTypes);

// Function to get the extension from MIME type
export function getExtensionFromMime(mimeTypes: string[]): string | undefined {
  return mimeTypes
    .map((mimeType) => {
      const extension = getExtensionFromMimeDbLibrary(mimeType);

      return extension ? extension.toUpperCase() : '';
    })
    .filter(Boolean)
    .join(', ');
}

// Helper function to get extension from the mime type
function getExtensionFromMimeDbLibrary(mimeType: string): string | undefined {
  const entry = mimeDb[mimeType];
  if (entry && entry.extensions && entry.extensions.length > 0) {
    return entry.extensions[0]; // returns the first extension associated with the MIME type
  }

  return undefined;
}
